import React from "react";
import { Box, Button, Typography, Grid, Container } from "@mui/material";
import { AiOutlineHome } from "react-icons/ai";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";

const Breadcrumb = ({ title }) => {
  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          background: " rgba(0, 139, 255, 0.25)",
          borderRadius: "6px",
          padding: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& ul": {
            padding: 0,
            textAlign:"center",
          },
          "& .breadcrumbList li": {
            display: "inline-flex",
            alignItems: "center",
            fontSize: "14px",
            lineHeight: "24px",
            fontWeight: "600",
            fontFamily: `"Lato", sans-serif`,
            color: "#7E7E7E",
          },
          "& .breadcrumbList li a": {
            color: "#15191D",
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          },
          "& .breadcrumbList li svg": {
            marginRight: "5px",
          },
          "& .resultcrumb li": {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "17px",
            lineHeight: "24px",
            fontWeight: "700",
            fontFamily: `"Quicksand", sans-serif`,
            color: "#15191D",
            border: "1px solid #ECECEC",
            boxShadow: "5px 5px 15px 0px #0000000D",
            background: "#FFFFFF",
            padding: "0 20px",
            height: "40px",
            borderRadius: "30px",
            marginLeft: "10px",
          },
          "& .resultcrumb li svg": {
            marginRight: "5px",
            fill: "#008BFF",
          },
        }}
      >
        <div>
          <Typography
            sx={{
              fontSize: "48px",
              lineHeight: "57.6px",
              fontWeight: "700",
              fontFamily: `"Quicksand", sans-serif`,
              color: "#253D4E",
            }}
          >
            {title}
          </Typography>
          <ul className="breadcrumbList">
            <li>
              <a href="/">
                <AiOutlineHome /> Home{" "}
              </a>
            </li>
            <li className="active">
              <MdOutlineKeyboardArrowRight />
              {title}
            </li>
          </ul>
        </div>
        {/* <div>
          <ul className="resultcrumb">
            <li>
              <IoCloseOutline /> Medical{" "}
            </li>
            <li>
              <IoCloseOutline /> Labs{" "}
            </li>
            <li>
              <IoCloseOutline /> Health{" "}
            </li>
            <li>
              <IoCloseOutline /> Ortho{" "}
            </li>
            <li>
              <IoCloseOutline /> Lifeline{" "}
            </li>
          </ul>
        </div> */}
      </Box>
    </Container>
  );
};

export default Breadcrumb;
